import { Component } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';

import {
    ExtendedBaseProfileField,
    FieldReadHelper,
    FormValue,
    GenericTypedValue,
    PartialRecord,
    ShComplexInputFieldComponent
} from '@stylehaven/components';
import { SimpleType } from '../../../../common/entities/common/simple-type.entity';
import { UserStoreService } from '../../../../common/services/user/user-store.service';
import { createPermissionInputRequiredValidator } from './permissions-input-required.validator';

@Component({
    selector: 'med-permissions-field',
    templateUrl: './permissions-input-field.component.html'
})
export class PermissionsInputFieldComponent extends ShComplexInputFieldComponent {
    constructor(
        protected fieldHelper: FieldReadHelper,
        private userStoreService: UserStoreService
    ) {
        super(fieldHelper);
    }

    init(profileField: ExtendedBaseProfileField, fragments: PartialRecord[], control: UntypedFormControl): void {
        const values: FormValue<GenericTypedValue<SimpleType>>[] = this.fieldHelper.getMergedMultiItemFieldValue(
            profileField.FieldDefinition,
            fragments
        );
        control.setValue(values);

        this.userStoreService.getAssignableUserGroups().subscribe(assignableUserGroups => {
            control.setValidators([createPermissionInputRequiredValidator(assignableUserGroups)]);
            control.updateValueAndValidity();
        });

        if (profileField.ReadOnly || profileField.FieldDefinition.ReadOnly) {
            control.disable();
        }
    }
}
